/*
 * Footer/hero background video — safety net.
 *
 * sat-app.js already assigns window.SAT_DATA.media.cinemagraph to the
 * <video ref="heroVideoRef"> in componentDidMount, once, right after first
 * mount. That single attempt fires while the app is still on the boot
 * screen — the footer (and its <video>) lives behind an <sc-if> gated on
 * state.view === 'site', so heroVideoRef.current is still null at that
 * point and the assignment silently no-ops.
 *
 * ---- Why the first version of this safety net still left the video
 * blank in production ----
 * That version retried on every render, but only until the FIRST time it
 * saw a non-null ref, then latched an `applied` flag and never touched the
 * video again. That's a mismatch with how this vdom's <sc-if> actually
 * behaves: it doesn't just wait once for the footer to appear, it tears
 * down and recreates the video element every time the boot -> site
 * transition (re)happens, which on the real boot sequence occurs more than
 * once (the intro replays a brief view flicker before settling). Each
 * teardown creates a brand-new <video> node and reassigns
 * heroVideoRef.current to it — but the OLD node was the one the latch had
 * already marked "done" against, so the final, real, on-screen video node
 * never got a src at all. Confirmed live: heroVideoRef.current was a
 * valid, connected DOM node with an empty src, and manually assigning
 * v.src to it worked instantly — the data and the ref were fine, only the
 * one-shot latch was wrong.
 *
 * The fix: don't latch on "did we ever succeed" — check the actual node's
 * current src against the target on every render, and (re)assign whenever
 * they don't match. This is idempotent (a no-op once they already match)
 * and self-healing against any future remount, the same pattern already
 * used for the popup-position cache elsewhere in this theme.
 */
(function () {
  'use strict';
  if (!window.SATComponent) { return; }

  function tryAssign(self) {
    var cinemagraph = (window.SAT_DATA && window.SAT_DATA.media && window.SAT_DATA.media.cinemagraph) || '';
    if (!cinemagraph) return;
    var v = self.heroVideoRef && self.heroVideoRef.current;
    if (!v) return;
    if (v.src === cinemagraph) return; // already correct on this node — nothing to do
    v.src = cinemagraph;
    v.muted = true;
    v.loop = true;
    v.playsInline = true;
    v.addEventListener('error', function () {
      console.warn('[sat] footer/hero cinemagraph failed to load — check the file still exists under Content → Files:', cinemagraph);
    }, { once: true });
    var p = v.play();
    if (p && typeof p.catch === 'function') p.catch(function () {});
  }

  var orig = window.SATComponent.prototype.renderVals;
  window.SATComponent.prototype.renderVals = function () {
    var out = orig.call(this);
    tryAssign(this);
    return out;
  };
})();
